



























import { defineComponent, PropType, reactive, ref, watch } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import { InputProps, inputProps, useDisplayLabel } from '../../formUtils';
import rules from '../../rules';

rules();

export default defineComponent({
	components: { ValidationProvider },
	props: {
		...inputProps,
		type: {
			required: false,
			default: 'text',
			type: String as PropType<'text' | 'email' | 'password' | 'date'>,
		},
		numeric: {
			required: false,
			default: false,
			type: Boolean,
		},
		noErrorMessages: {
			type: Boolean,
		},
	},

	setup(props, { emit }) {
		const { displayLabel } = useDisplayLabel(props);
		const input = ref();
		const state = reactive({
			additionalRules: '',
		});
		watch(props, () => {
			if (props.type === 'date') {
				const dateValidationParams: (keyof InputProps)[] = ['min', 'max'];
				dateValidationParams.forEach((key) => {
					props[key] && (state.additionalRules += `|${key}Date:${Date.parse(props[key] as string)}`);
				});
			}
		});

		const onInput = (e: InputEvent) => {
			const value = (e.target as HTMLInputElement).value;

			if (props.numeric && value !== '' && !/^[0-9]+$/.test(value)) return;

			emit('input', value);
		};

		return { displayLabel, state, input, onInput };
	},
});
